import * as React from "react";

import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { useProvidedState } from "@shared-ui/provided-state-context";

import { WizardTabbed } from "components/shared/StorefrontWizard/WizardTabbed/WizardTabbed";
import { WizardHero } from "components/shared/StorefrontWizard/WizardHero/WizardHero";
import { FlexComponent } from "src/typings/flexFramework/FlexComponent";
import { ClientWizardStateStore } from "src/stores/wizard/ClientWizardStateStore";
import { UitkSpacingProps, UitkSpacing } from "uitk-react-spacing";
import { Experiment, isVariantEnabled } from "components/utility/experiment";

export const StorefrontWizardRegionBEXView = (props: {
  heroImageSrc: string;
  heroImageFigureClassNames?: string;
  context: any;
  trackOnChangeTab: (tab: string) => void;
  wizardFormChildren: React.ReactElement[];
  wizardLOBs: FlexComponent[];
  wizardState: ClientWizardStateStore;
  otherFormChildren: React.ReactElement[];
}) => {
  const [data] = useProvidedState();
  const isTripsHeroActive = data?.tripsHero?.isRendered ?? false;
  const className = !isTripsHeroActive ? "StorefrontWizardRegionBEX" : "StorefrontWizardRegionBEXTripsHero";
  const reasonsToBelieveOn = isVariantEnabled(props.context, Experiment.Surface_PWA_SF_Travel_Advisory_Chatbot, 2);

  const regularSpacing: UitkSpacingProps = reasonsToBelieveOn
    ? { padding: { small: { blockend: "six" } }, margin: { extra_large: { blockend: "twelve" } } }
    : { padding: { blockend: "six" }, margin: { extra_large: { blockend: "twelve" } } };

  const regionSpacing: UitkSpacingProps = isTripsHeroActive
    ? { padding: { blockend: "unset" }, margin: { blockend: "unset" } }
    : regularSpacing;

  return (
    <UitkSpacing {...regionSpacing}>
      <div className={`${className}`} data-testid="storefront-region">
        <div data-testid="main-region">
          <Viewport>
            <ViewSmall>
              <WizardTabbed
                wizardLOBs={props.wizardLOBs}
                context={props.context}
                wizardFormChildren={props.wizardFormChildren}
                trackOnChangeTab={props.trackOnChangeTab}
              />
            </ViewSmall>
            <ViewMedium>
              <WizardHero
                heroImageSrc={props.heroImageSrc}
                heroImageFigureClassNames={`bexHeroImageFigure ${props.heroImageFigureClassNames}`}
                context={props.context}
                trackOnChangeTab={props.trackOnChangeTab}
                wizardFormChildren={props.wizardFormChildren}
                wizardLOBs={props.wizardLOBs}
                wizardState={props.wizardState}
              />
            </ViewMedium>
          </Viewport>

          {props.otherFormChildren}
        </div>
      </div>
    </UitkSpacing>
  );
};
